import { PanelIndicatorEnum } from '@app/components/overview-panel/enum/panel-indicator.enum';
import { ContactInterface } from '@app/interfaces/contact.interface';
import { DocumentInterface } from '@app/interfaces/document.interface';
import { DOCUMENTS_STATUSES_ORDER, DocumentStatusEnum } from '@app/enums/document-status.enum';
import { DocumentGroupEnum } from '@app/enums/document-group.enum';

export class DocumentsUtils {
    static findIndicator(documentsArray: DocumentInterface[] = []): PanelIndicatorEnum {
        let indicator = PanelIndicatorEnum.Waiting;
        if (documentsArray.length) {
            if (documentsArray.some((a) => a.status === DocumentStatusEnum.denied)) {
                indicator = PanelIndicatorEnum.Danger;
            } else if (documentsArray.some((a) => a.status === DocumentStatusEnum.waiting)) {
                indicator = PanelIndicatorEnum.Warning;
            } else if (documentsArray.some((a) => a.status === DocumentStatusEnum.checking)) {
                indicator = PanelIndicatorEnum.Waiting;
            } else if (documentsArray.some((a) => a.status === DocumentStatusEnum.sent)) {
                indicator = PanelIndicatorEnum.Waiting;
            } else if (documentsArray.some((a) => a.status === DocumentStatusEnum.checked)) {
                indicator = PanelIndicatorEnum.Waiting;
            } else if (documentsArray.every((a) => a.status === DocumentStatusEnum.done)) {
                indicator = PanelIndicatorEnum.Success;
            }
        }

        return indicator;
    }

    static documentsComparator(a: DocumentInterface, b: DocumentInterface): number {
        if (a.drawdownIndex < b.drawdownIndex) {
            return -1;
        }

        if (a.drawdownIndex > b.drawdownIndex) {
            return 1;
        }

        const aStatusOrder = DOCUMENTS_STATUSES_ORDER.indexOf(a.status);
        const bStatusOrder = DOCUMENTS_STATUSES_ORDER.indexOf(b.status);
        if (aStatusOrder > 0 && bStatusOrder > 0) {
            if (aStatusOrder < bStatusOrder) {
                return -1;
            }
            if (aStatusOrder > bStatusOrder) {
                return 1;
            }
        }

        if (a._template.isApplicantRelated || b._template.isApplicantRelated) {
            if (a.applicantIndex < b.applicantIndex) {
                return -1;
            }
            if (a.applicantIndex > b.applicantIndex) {
                return 1;
            }
        }

        if (a._template?.order < b._template?.order) {
            return -1;
        }
        if (a._template?.order > b._template?.order) {
            return 1;
        }

        return a._template?.name.localeCompare(b._template?.name, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    }

    static transformDocuments(documents: DocumentInterface[] = [], applicants: ContactInterface[] = []) {
        documents?.forEach((document: DocumentInterface) => {
            const applicantIndex = applicants?.findIndex((a) => a._id === document.contactId);
            document.applicantIndex = applicantIndex !== -1 ? applicantIndex : 999;
        });
    }

    static getDocumentsFromGroup(
        documents: DocumentInterface[],
        documentGroup: DocumentGroupEnum
    ): DocumentInterface[] {
        return documents
            ?.filter(({ _template }) => _template.groupId === documentGroup)
            .sort(DocumentsUtils.documentsComparator);
    }

    static getWaitingDocuments(
        documents: DocumentInterface[],
        includedDocumentGroups: DocumentGroupEnum[]
    ): DocumentInterface[] {
        return documents
            ?.filter(
                (document) =>
                    includedDocumentGroups.includes(document._template?.groupId) &&
                    [DocumentStatusEnum.sendOriginals, DocumentStatusEnum.waiting].includes(document.status)
            )
            .sort(DocumentsUtils.documentsComparator);
    }

    static isWaitingForSignature(document: DocumentInterface) {
        return (
            document.status === DocumentStatusEnum.waiting &&
            document.files.some((file) => file.isDeliveredByUs && !file.isHidden)
        );
    }
}
